export default __webpack_public_path__ + "static/media/detail_mobile_10_1.32860ed4.jpg";